var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "frb" }, [
          _c("div", { staticClass: "title fc" }, [_vm._v("淘宝联盟")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.UpdateAuthorization("TB")
                    },
                  },
                },
                [_vm._v("更新授权")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onEditor("TB")
                    },
                  },
                },
                [_vm._v("编辑")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [
            _vm._v("淘宝联盟-MemberId:"),
          ]),
          _vm._v(_vm._s(_vm.loadConfigData.tbMemberId || "-") + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _vm._v(
            "\n      淘宝联盟-推广位:" +
              _vm._s(_vm.loadConfigData.tbPid || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _vm._v(
            "\n      淘宝联盟-授权账户:" +
              _vm._s(_vm.loadConfigData.tbUserNick || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _vm._v(
            "\n      淘宝联盟-授权过期时间:" +
              _vm._s(_vm.loadConfigData.tbExpireTime || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _vm._v(
            "\n      淘宝联盟-appKey:" +
              _vm._s(_vm.loadConfigData.tbAppKey || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _vm._v(
            "\n      淘宝联盟-appSecret:" +
              _vm._s(_vm.loadConfigData.tbAppSecret || "-") +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "frb" }, [
          _c("div", { staticClass: "title fc" }, [_vm._v("京东联盟")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.UpdateAuthorization("JD")
                    },
                  },
                },
                [_vm._v("更新授权")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onEditor("JD")
                    },
                  },
                },
                [_vm._v("编辑")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [_vm._v("京东联盟-联盟ID:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.loadConfigData.jdUnionId || "-") + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [
            _vm._v("京东联盟-授权到期时间:"),
          ]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.loadConfigData.jdExpireTime || "-") +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "frb" }, [
          _c("div", { staticClass: "title fc" }, [_vm._v("多多进宝")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onEditor("PDD")
                    },
                  },
                },
                [_vm._v("编辑")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [
            _vm._v("多多进宝-ClientId:"),
          ]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.loadConfigData.pddClientId || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [
            _vm._v("多多进宝-ClientSecret:"),
          ]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.loadConfigData.pddClientSecret || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [_vm._v("多多进宝-媒体ID:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.loadConfigData.pddMediaId || "-") + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [
            _vm._v("多多进宝-多多客ID:"),
          ]),
          _vm._v(
            "\n      " + _vm._s(_vm.loadConfigData.pddDuoId || "-") + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "frb" }, [
          _c("div", { staticClass: "title fc" }, [_vm._v("唯品会")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onEditor("WPH")
                    },
                  },
                },
                [_vm._v("编辑")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [_vm._v("唯品会-appKey:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.loadConfigData.wphAppKey || "-") + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [
            _vm._v("唯品会-appSecret:"),
          ]),
          _vm._v(
            "\n      " +
              _vm._s(_vm.loadConfigData.wphAppSecret || "-") +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item_box" }, [
          _c("span", { staticClass: "name_box" }, [_vm._v(" 唯品会-推广位:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.loadConfigData.wphPid || "-") + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.title,
            "close-on-click-modal": false,
            width: "750px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            {},
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                    "label-position": "right",
                  },
                },
                [
                  _vm.platformType === "TB"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "淘宝联盟-MemberId:",
                            prop: "tbMemberId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.tbMemberId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tbMemberId", $$v)
                              },
                              expression: "form.tbMemberId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "TB"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "淘宝联盟-推广位:", prop: "tbPid" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.tbPid,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tbPid", $$v)
                              },
                              expression: "form.tbPid",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "TB"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "淘宝联盟-appKey:",
                            prop: "tbAppKey",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.tbAppKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tbAppKey", $$v)
                              },
                              expression: "form.tbAppKey",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "TB"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "淘宝联盟-appSecret:",
                            prop: "tbAppSecret",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.tbAppSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tbAppSecret", $$v)
                              },
                              expression: "form.tbAppSecret",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "JD"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "京东联盟-联盟ID:",
                            prop: "jdUnionId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.jdUnionId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "jdUnionId", $$v)
                              },
                              expression: "form.jdUnionId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "PDD"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "多多进宝-ClientId:",
                            prop: "pddClientId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.pddClientId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pddClientId", $$v)
                              },
                              expression: "form.pddClientId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "PDD"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "多多进宝-ClientSecret",
                            prop: "pddClientSecret",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.pddClientSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pddClientSecret", $$v)
                              },
                              expression: "form.pddClientSecret",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "PDD"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "多多进宝-媒体ID",
                            prop: "pddMediaId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.pddMediaId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pddMediaId", $$v)
                              },
                              expression: "form.pddMediaId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "PDD"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "多多进宝-多多客ID",
                            prop: "pddDuoId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.pddDuoId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "pddDuoId", $$v)
                              },
                              expression: "form.pddDuoId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "WPH"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "唯品会-appKey", prop: "wphAppKey" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.wphAppKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "wphAppKey", $$v)
                              },
                              expression: "form.wphAppKey",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "WPH"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "唯品会-appSecret",
                            prop: "wphAppSecret",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.wphAppSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "wphAppSecret", $$v)
                              },
                              expression: "form.wphAppSecret",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.platformType === "WPH"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "唯品会-推广位", prop: "wphPid" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.wphPid,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "wphPid", $$v)
                              },
                              expression: "form.wphPid",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("formRef")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("formRef")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "frb" }, [
      _c(
        "div",
        {
          staticClass: "fc",
          staticStyle: { "font-weight": "bold", "font-size": "20px" },
        },
        [_vm._v("\n      联盟授权列表\n    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }